import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";

/**
 * Redirect to Google Maps with store location
 * @param {number} lat - latitude of the store
 * @param {number} lng - longitude of the store
 */
const redirectToGoogleMaps = (lat, lng) => {
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  window.open(googleMapsUrl, "_blank");
};

export const ObtbList = ({
  obtb,
  handleStoreDetailClicked,
  setModalIsOpen,
  all=false
}) => {
  return (
    <>
      {obtb.length > 0 ? (
        obtb?.map((store, index) => {
          return (
            <div className="obl_store_locator_col" key={index}>
              <div className="store_obl_logo">
                <img src="/store_obl_logo_icon.svg" />
              </div>
              {/* <h3 onClick={()=>router.push(`/store-locator/${store.id}`)}>{store.d_name.replace("&amp;", "&")}</h3> */}

              {/* <h3 >{store.d_name.replace("&amp;", "&")}</h3> */}
              <h3>{store.business_name}</h3>
              <div className="store_add_row">
                <div className="store_add_text">
                  <h6>{store.address_1 ? store.address_1.replace("&amp;", "&") : ""}</h6>
                  <p>{store.address_2 ? store.address_2.replace("&amp;", "&") : ""}</p>
                  <p>
                    {store.city}, {store.state}{" "}
                  </p>
                  <button
                    className="add-sec"
                    onClick={() => handleStoreDetailClicked(store)}
                  >
                    More Details
                  </button>
                </div>
                {/* <div
                  className="store_add_icon"
                  onClick={() => redirectToGoogleMaps(store.lat, store.longt)}
                >
                  <img src="/duration.svg" />
                </div> */}
                <div className="store_add_icon">
                  <div className="store-whatsapp-icon">
                    <span onClick={() => setModalIsOpen(store)}>
                      <svg
                        stroke="green"
                        fill="green"
                        stroke-width="0"
                        viewBox="0 0 448 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
                      </svg>
                    </span>
                  </div>
                  <div
                    className="store-duration-icon"
                    onClick={() => redirectToGoogleMaps(store.lat, store.longt)}
                  >
                    <img src="/duration.svg" />
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) :
       (
         <>
         {
          all == true ? <></> :
        
        <div className="no-store-row">
        <h2>Oops!! No Store Found</h2>
        </div>
        }
        </>
      )}
    </>
  );
};

export const NonObtbList = ({
  nonObtb,
  handleNonObtbClick,
  setModalIsOpen,
  all=false
}) => {
  return nonObtb?.map((store, index) => (
    <div className="obl_store_locator_col" key={`nonObtb-${index}`}>
      <h3>{store.name}</h3>
      <div className="store_add_row">
        <div className="store_add_text">
          <h6>{store.address}</h6>
          <p>
            {store.city}, {store.state_desc}
          </p>
          <button className="add-sec" onClick={() => handleNonObtbClick(store)}>
            More Details
          </button>
        </div>
        <div className="store_add_icon">
          <div className="store-whatsapp-icon">
            <span onClick={() => setModalIsOpen(store)}>
              <svg
                stroke="green"
                fill="green"
                stroke-width="0"
                viewBox="0 0 448 512"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
              </svg>
            </span>
          </div>
          <div
            className="store-duration-icon"
            onClick={() =>
              redirectToGoogleMaps(store.latitude, store.longitude)
            }
          >
            <img src="/duration.svg" alt="Duration Icon" />
          </div>
        </div>
      </div>
    </div>
  ));
};

export const WtspModel = ({ modalIsOpen, setModalIsOpen }) => {
  // Yup validation schema
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    phone: Yup.string().required("Mobile Number is required"),
    city: Yup.string().required("City is required"),
    message: Yup.string(),
  });

  // Initial values for Formik
  const initialValues = {
    name: "",
    phone: "",
    city: "",
    message: "",
  };

  const sendSms = async (values) => {
    if (!modalIsOpen) {
      return;
    }

    let d1 =
      modalIsOpen.__typename === "Obtbs"
        ? modalIsOpen.business_name
        : modalIsOpen.name;
    let d2 = values.name;
    let d3 = values.city;
    let d4 = values.phone;
    let d5 = values.message;
    let U1 = values.name;
    let U2 =
      modalIsOpen.__typename === "Obtbs"
        ? modalIsOpen.business_name
        : modalIsOpen.name;
    let U3 =
      modalIsOpen.__typename === "Obtbs"
        ? `${modalIsOpen.address_1 ? modalIsOpen.address_1 : ""},${
            modalIsOpen.address_2 ? modalIsOpen.address_2 : ""
          },${modalIsOpen.city ? modalIsOpen.city : ""},${
            modalIsOpen.state ? modalIsOpen.state : ""
          },${modalIsOpen.postcode ? modalIsOpen.postcode : ""}`
        : `${modalIsOpen.address ? modalIsOpen.address : ""},${
            modalIsOpen.address_2 ? modalIsOpen.address_2 : ""
          },${modalIsOpen.city ? modalIsOpen.city : ""},${
            modalIsOpen.state_desc ? modalIsOpen.state_desc : ""
          }`;
    let U4 =
      modalIsOpen.__typename === "Obtbs"
        ? modalIsOpen.main_phone_no
        : modalIsOpen.phone_no;

    let obj = {
      d1,
      d2,
      d3,
      d4,
      d5,
      U1,
      U2,
      U3,
      U4,
      userPhone: values.phone,
      dealerPhone: modalIsOpen.d_phone_no,
    };

    try {
      const res = await axios.post(
        "https://proxy.orientbell.com/send-storelocator-sms",
        obj
      );
      if (res.status === 200) {
        setModalIsOpen(false);
        swal(
          `Thank you for your interest in our tiles. We have shared the requested store's details on your WhatsApp`
        );
      } else {
        setModalIsOpen(false);
        swal(
          "We are unable to send the address to your mobile, please try again later."
        );
      }
    } catch (error) {
      console.error("Error sending SMS:", error);
      swal("Something went wrong. Please try again later.");
    }
  };

  return (
    <Modal
      show={modalIsOpen}
      className="pincode-popup-bx"
      onHide={() => setModalIsOpen(false)}
    >
      <Modal.Dialog>
        <Modal.Header closeButton>
          <Modal.Title>Send this address on WhatsApp to me</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              sendSms(values);
              setSubmitting(false);
              resetForm();
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                <label>Name</label>
                <Field type="text" name="name" />
                <ErrorMessage
                  name="name"
                  component="p"
                  className="error text-danger"
                />

                <label>Mobile Number</label>
                <Field type="number" name="phone" />
                <ErrorMessage
                  name="phone"
                  component="p"
                  className="error text-danger"
                />

                <label>City</label>
                <Field type="text" name="city" />
                <ErrorMessage
                  name="city"
                  component="p"
                  className="error text-danger"
                />

                <label>Message</label>
                <Field type="text" name="message" />
                <ErrorMessage
                  name="message"
                  component="p"
                  className="error text-danger"
                />

                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                  style={{ width: "100%" }}
                >
                  Submit
                </Button>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal.Dialog>
    </Modal>
  );
};
